import { Send, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  const destinations = {"Все курсы":"/courses", "Веб-разработка":"/courses?category=Веб%20разработка", "Веб дизайн":"/courses?category=Веб%20Дизайн", "Программы Adobe":"/courses?q=Adobe", "Частые вопросы":"/#faq", "Блог":"/blog"};
  const footerLinks = {
    "Обучение": ["Все курсы", "Веб-разработка", "Веб дизайн", "Программы Adobe", "Блог"],
    "Поддержка": ["Частые вопросы", "Политика конфиденциальности", "Публичная оферта"]
  };

  return (
    <footer className="bg-[#E4DED1] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img loading="lazy"
              src="/images/brand/fokeev-wordmark-paper-v2.svg"
              alt="Fokeev"
              className="h-5 w-auto mb-4"
            />
            <p className="text-gray-400 leading-relaxed mb-6 max-w-sm">
              Курсы по дизайну, разработке и нейросетям с видеоуроками и практическими заданиями.
            </p>

            {/* Telegram CTA */}
            <a
              href="https://t.me/DmitriiFokeevEducation"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                if (typeof window.ym === "function") {
                  window.ym(107179621, "reachGoal", "telegram_click");
                }
              }}
              className="inline-flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-5 py-3 hover:bg-white/10 hover:border-teal-500/30 transition-all duration-300 group"
            >
              <div className="w-10 h-10 rounded-lg bg-teal-500/20 flex items-center justify-center">
                <Send size={18} className="text-teal-400" />
              </div>
              <div>
                <div className="text-sm font-semibold group-hover:text-teal-400 transition-colors">Наш Telegram канал</div>
                <div className="text-xs text-gray-500">Подписывайтесь</div>
              </div>
            </a>
          </div>

          {/* Обучение column */}
          <div>
            <h4 className="font-semibold text-white mb-4">Обучение</h4>
            <ul className="space-y-3">
              {footerLinks["Обучение"].map((link) => (
                <li key={link}>
                  <a href={destinations[link]} className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Поддержка column */}
          <div>
            <h4 className="font-semibold text-white mb-4">Поддержка</h4>
            <ul className="space-y-3">
              {footerLinks["Поддержка"].map((link) => (
                <li key={link}>
                  {link === "Публичная оферта" ? (
                    <Link to="/public-offer" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                      {link}
                    </Link>
                  ) : link === "Политика конфиденциальности" ? (
                    <Link to="/privacy-policy" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                      {link}
                    </Link>
                  ) : (
                    <a href={destinations[link]} className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                      {link}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Business Info column */}
          <div>
            <h4 className="font-semibold text-white mb-4">ИП Фокеев Дмитрий Сергеевич</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li>ИНН: 780626085106</li>
              <li>ОГРНИП: 324784700300420</li>
              <li>
                <a href="mailto:hello@dmitrii-fokeev.ru" className="hover:text-teal-400 transition-colors flex items-center gap-2">
                  <Mail size={14} />
                  hello@dmitrii-fokeev.ru
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">© 2026 Fokeev. Все права защищены.</p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="text-gray-500 hover:text-teal-400 transition-colors text-sm">Политика конфиденциальности</Link>
            <Link to="/public-offer" className="text-gray-500 hover:text-teal-400 transition-colors text-sm">Публичная оферта</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
